export const CookieMap = {
  /**
   * Horizon session token
   */
  JWT: 'flagsync',
  /**
   * CSRF token
   */
  CSRF: 'flagsync_csrf',
  /**
   * Organization context
   */
  ORG_CTX: 'flagsync_org_ctx',
  /**
   * Complete signup token
   */
  CSU: 'flagsync_csu',
  /**
   * Thank you token
   */
  TYT: 'flagsync_ty',
  /**
   * Thank you token
   */
  VIS: 'flagsync_vid',
  /**
   * Thank you token
   */
  USR: 'flagsync_uid',
} as const;
